export const REDUX_NAMESPACE = 'media-trimmer';
